

/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import React, { memo } from 'react';
import Icon from '../../../ui-kit/components/Icon';
import Text from '../../../ui-kit/components/Text';
import { FLATTENED_COLOURS } from '../../../ui-kit';

import '../styles/_ai-tool-list-item.scss';











/**
 * A component to render an AI tool card in the AI tool list
 *
 * @param {AIToolListItemProps} props
 *
 * @return {React.Element}
 */

const AIToolListItem = ({
  icon,
  title,
  description,
  isSelected,
  bgColorOnSelect,
  borderColorOnSelect,
  onSelect
}) =>
<div
  className="tool-card-item"
  style={{
    borderColor: isSelected ?
    FLATTENED_COLOURS[borderColorOnSelect] :
    '#D4D9E2',
    background: isSelected ? FLATTENED_COLOURS[bgColorOnSelect] : '#FFF'
  }}
  onClick={onSelect}>

    <Icon name={icon} color="nevada" />
    <Text className="tool-card-item__title">{title}</Text>
    <Text className="tool-card-item__description" subtitle>
      {description}
    </Text>
  </div>;


export default memo(AIToolListItem);